define('lib/collection/TimeGroupCollection',['require','backbone','lib/collection/BaseCollection','model/TimeSlotModel','model/GroupedTimeSlotsModel','Config'],function (require) {

    var Backbone = require('backbone');
    var BaseCollection = require('lib/collection/BaseCollection');
    var TimeSlotModel = require('model/TimeSlotModel');
    var GroupedTimeSlotsModel = require('model/GroupedTimeSlotsModel');
    var Config = require('Config');

    // If true, getCollectionGroupedByTimeline will generate 'breaktime' timeslots outside actual
    // working hours, to match given timeline;
    // otherwise only timeslots withing actual worktime will be returned
    // TODO choose best option
    var EXTEND_TO_FULL_TIMELINE = true;

    /**
     * Flexible timeline collection
     *
     * @class TimeFlexibleCollection
     */
    return BaseCollection.extend({

        model: TimeSlotModel,
        _hourCollection: null,
        _dayCollection: null,

        /**
         * Initializes object
         */
        initialize: function () {
            this._hourCollection = new Backbone.Collection();
            this._dayCollection = new Backbone.Collection();

            BaseCollection.prototype.initialize.apply(this);
        },

        /**
         * Returns collection that contains information for each hour
         *
         * @return Backbone.Collection
         */
        getCollectionGroupedByHour: function () {
            this._hourCollection.reset();

            var models = [];
            var time = null;
            var date = null;

            this.each(_.bind(function (model) {
                var timeObj = new Time(model.get('time'));
                date = Date.parseMysqlDate(model.get('date'));

                if (time && time.getHours() !== timeObj.getHours()) {
                    this._addModelsToHourCollection(models, time, date);

                    models = [];
                }
                time = timeObj;
                models.push(model);
            }, this));
            if (models.length) {
                this._addModelsToHourCollection(models, time, date);
            }

            return this._hourCollection;
        },

        /**
         * Returns collection that contains information for each hour arranged by given timeline
         * Intentionally uses same _hourCollection property, as getCollectionGroupedByHour()
         * @param {Date[]} timeline
         * @return Backbone.Collection
         */
        getCollectionGroupedByTimeline: function (timeline) {
            this._hourCollection.reset();

            var timeframe = Config.getInstance().getTimeFrame();

            _.each(timeline, function(datetime) {
                var timelineDate = new Date(datetime);
                timelineDate.setHours(0,0,0,0);
                var timelineDateStr = timelineDate.getMysqlDate();
                var timelineTime = datetime.getTimeObj();
                var models = [];

                if (EXTEND_TO_FULL_TIMELINE) {
                    // add all timeslots for this hour, some of them will be 'breaktime'
                    for (var relSlot = 0; relSlot < 60; relSlot += timeframe) {
                        var time = new Time(timelineTime.getInteger() + relSlot);
                        var timeStr = time.getFormattedTime('24hr');

                        var modelDate = new Date(timelineDate);
                        modelDate.setHours(time.getHours());
                        modelDate.setMinutes(time.getMinutes());
                        var modelId = modelDate.getMysqlDateTime();
                        var model = this.get(modelId);

                        if (model) {
                            models.push(model);
                        }
                        else {
                            models.push(new TimeSlotModel({
                                'id': modelId,
                                'time': timeStr,
                                'date': timelineDateStr,
                                'type': 'breaktime'
                            }));
                        }
                    }

                }
                else {
                    this.each(function(model) {
                        var time = new Time(model.get('time'));
                        var date = Date.parseMysqlDate(model.get('date'));
                        date.setHours(0,0,0,0);

                        if (time.getHours() == timelineTime.getHours() && !(timelineDate - date)) {
                            models.push(model);
                        }
                    });
                }

                this._addModelsToHourCollection(models, timelineTime, timelineDate);
            }, this);

            return this._hourCollection;
        },

        /**
         * Returns collection that contains information for each day.
         * Takes into account client timezone
         *
         * @return Backbone.Collection
         */
        getCollectionGroupedByClientDay: function (dayFrom, dayTo) {
            if(dayFrom && dayTo) {
                return this._getCollectionGroupedByDayInterval('client_date', dayFrom, dayTo);
            } else {
                return this._getCollectionGroupedByDay('client_date');
            }
        },

        /**
         * Returns collection that contains information for each day
         *
         * @return Backbone.Collection
         */
        getCollectionGroupedByDay: function () {
            return this._getCollectionGroupedByDay('date');
        },

        /**
         * Returns collection that contains information for each day
         *
         * @return Backbone.Collection
         */
        _getCollectionGroupedByDay: function (field) {
            this._dayCollection.reset();

            var models = [];
            var date = null;

            this.each(_.bind(function (model) {
                var dateObj = Date.parseMysqlDate(model.get(field));
                if (date && date.getDate() !== dateObj.getDate()) {
                    this._addModelsToDayCollection(models, date);

                    models = [];
                }
                date = dateObj;
                models.push(model);
            }, this));
            if (models.length) {
                this._addModelsToDayCollection(models, date);
            }

            return this._dayCollection;
        },

        /**
         * Returns collection that contains information for each day
         *
         * @return Backbone.Collection
         */
        _getCollectionGroupedByDayInterval: function (field, dayFrom, dayTo) {
            this._dayCollection.reset();
            var models = [];

            dayFrom = Date.parseMysqlDate(dayFrom);
            dayTo = Date.parseMysqlDate(dayTo);
            var i = new Date();

            for(i.setTime(dayFrom.getTime()); i<=dayTo; i.setDate(i.getDate() + 1) ) {
                models = [];
                this.each(_.bind(function (model) {
                    var dateObj = Date.parseMysqlDate(model.get(field));
                    if (dateObj && dateObj.getDate() === i.getDate()) {
                        models.push(model);
                    }
                }, this));
                this._addModelsToDayCollection(models, i);
            }

            return this._dayCollection;
        },

        /**
         * Adds models to hour collection
         *
         * @param models
         * @param time
         * @param date
         * @private
         */
        _addModelsToHourCollection: function (models, time, date) {
            this._hourCollection.add(new GroupedTimeSlotsModel({
                'collection': new Backbone.Collection(models),
                'time': time.getHours() + ':00',
                'date': date.getMysqlDate()
            }));
        },

        /**
         * Adds models to hour collection
         *
         * @param models
         * @param date
         * @private
         */
        _addModelsToDayCollection: function (models, date) {
            this._dayCollection.add(new GroupedTimeSlotsModel({
                'collection': new Backbone.Collection(models),
                'date': date.getMysqlDate()
            }));
        },
        
        
        isEmptyDayCollection : function () {
            var tAvTimes = [];
            this._dayCollection.each(function (dayModel) {
                var dayCollection = dayModel.get('collection');
                dayCollection.each(function (model) {
                    tAvTimes.push(model.toJSON());
                });
            });

            var isEmpty = true;

            _.each(tAvTimes, function (slot) {
                if(slot.type == 'free'){
                    isEmpty = false;
                }
            });

            return isEmpty;
        }

    });

});

